var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn_transparent btn_square btn_link",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"icon-CI_excel-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }